// BILL-20a — the billing feature's surface for OTHER features (design
// Pre-resolved decisions, the one Convention divergence): documents, settings
// and the dashboard layout import from here, not from internal files. One
// exception: workspaces/entitlement.ts imports useCapability/entitlementStore
// directly (D-P8), because it sits in the nav-rail predicate graph.
// Export only what another feature imports.
export { PlanUpsell } from './PlanUpsell';
export { showPlanUpsellToast } from './planUpsellToast';
export { useCapability, useGateTier } from './useCapability';
